import { render, staticRenderFns } from "./KnImagesGalleryContainer.vue?vue&type=template&id=25c3c867&"
import script from "./KnImagesGalleryContainer.vue?vue&type=script&lang=js&"
export * from "./KnImagesGalleryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports